import { Component, inject, Inject, Input, Optional } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'career-details',
  imports: [CommonModule, MaterialModule],
  templateUrl: './career-details.component.html',
  styleUrl: './career-details.component.scss',
})
export class CareerDetailsComponent {
  @Input() candidate: any;
  private _bottomSheetRef: any;
  @Input() showCloseButton = true;

  constructor(@Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public data?: any) {
    this.candidate = data;
    if (this.candidate?.resume_analysis?.candidate_id) {
      this._bottomSheetRef =
        inject<MatBottomSheetRef<CareerDetailsComponent>>(MatBottomSheetRef);
    } else {
      this.showCloseButton = false;
    }
  }

  getTotalExperience() {
    let experience = 0;
    if (this.candidate?.resume_analysis?.resume_analysis?.work_experience?.length > 0) {
    this.candidate?.resume_analysis?.resume_analysis?.work_experience?.forEach((item: any) => {
      experience += item?.total_years_experience;
    });
    }
    return experience;
  }

  close() {
    this._bottomSheetRef.dismiss();
  }
}
